<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
		<div class="form-group" [formGroup]="form">
			<app-unit-quantity [units]="medicationAmountUnits" label="Amount Given" inputMode="decimal" placeholder="Value" formControlName="amountGiven"></app-unit-quantity>
		</div>
		<app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
	</div>
</app-action-form>